import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { PropsWithChildren } from 'react';

export const ApolloClientProvider = ({
  children,
  apolloClient
}: PropsWithChildren<{ apolloClient: ApolloClient<NormalizedCacheObject> }>): JSX.Element => {

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
